import {
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableHeader,
    TableRow,
} from '../../ui/table';

interface Column<T> {
    key: string;
    header: string;
    className?: string;
    headerClassName?: string;
    cell: (item: T) => React.ReactNode;
}

interface FacilitiesTableProps<T extends { _id: string }> {
    facilities: T[];
    columns: Column<T>[];
    emptyMessage: string;
    onRowClick?: (item: T) => void;
    className?: string;
}

export default function FacilitiesTable<T extends { _id: string }>({
    facilities,
    columns,
    emptyMessage,
    onRowClick,
    className,
}: FacilitiesTableProps<T>) {
    return (
        <Table className={className}>
            <TableHeader>
                <TableRow className="hover:bg-transparent">
                    {columns.map((column) => (
                        <TableHead
                            key={column.key}
                            className={column.headerClassName}
                        >
                            {column.header}
                        </TableHead>
                    ))}
                </TableRow>
            </TableHeader>
            <TableBody>
                {facilities.length === 0 ? (
                    <TableRow className="hover:bg-transparent">
                        <TableCell
                            colSpan={columns.length}
                            className="px-4 py-10 text-center text-xs text-muted-foreground"
                        >
                            {emptyMessage}
                        </TableCell>
                    </TableRow>
                ) : (
                    facilities.map((item) => (
                        <TableRow
                            key={item._id}
                            className={onRowClick ? 'cursor-pointer' : ''}
                            onClick={() => onRowClick?.(item)}
                        >
                            {columns.map((column) => (
                                <TableCell
                                    key={column.key}
                                    className={column.className}
                                >
                                    {column.cell(item)}
                                </TableCell>
                            ))}
                        </TableRow>
                    ))
                )}
            </TableBody>
        </Table>
    );
}
